import { FlowTypes } from '@interfaces/models/flow-types';
import { Store } from '@ngrx/store';
import { ContentPageId } from '@shared/models/content-page-ids';
import { type OpenchoiceRemoteContent } from '@src/aem/models/OpenchoiceRemoteContent';
import { createSafeGetFactory } from '@src/aem/utils';
import { State } from '@store/index';

export const toPageContent = (remoteContent: OpenchoiceRemoteContent, store?: Store<State>) => {
  const title = remoteContent.data.checklists_toaEnrollInDigitialAdvisorChecklistItem.items[0];
  const button = remoteContent.data.nav_enrollAndContinueButton.items[0];
  const links = remoteContent.data.nav_commissionFeeSchedulelink.items[0];
  const safeGetForDaEnroll = createSafeGetFactory(ContentPageId.openchoice, FlowTypes.MINOR, store);

  // Retrieving the content from AEM and replacing the placeholder with the actual URL, so the correct link is displayed in the rendered content.
  const part2Raw =
    remoteContent.data.disclosures_transferNonVanguardSpecialAssetsDisclosure.items[0].body[0]
      .plaintext;
  const placeholder = '${commission-fee-schedule-link}';
  let part2 = part2Raw;
  let part3 = '';

  if (part2Raw.includes(placeholder)) {
    const [before, after] = part2Raw.split(placeholder);
    part2 = before.trimEnd() + ' ';
    part3 = ' ' + after.trimStart();
  }

  return {
    pageTitle: safeGetForDaEnroll(() => title.heading, 'pageTitle'),
    continueButton: safeGetForDaEnroll(() => button.labelText, 'continueButton'),
    disclaimer: {
      part1:
        remoteContent.data.disclosures_gcSharedDaProjectedInvestmentsDisclosure.items[0].body[0]
          .plaintext,
      part2: part2,
      part3: part3,
      linkHref: safeGetForDaEnroll(() => links.url, 'linkHref'),
      linkText: safeGetForDaEnroll(() => links.labelText, 'linkText'),
    },
  };
};
